import { Immutability, RFC3339timestamp, UUID } from "@bitory-gmbh/nidavellir";
import { DocumentOwnership } from "@bitory-gmbh/bsm";
import { v4 } from "uuid";

export type Pricing = {
  id: UUID;
  companyId: UUID;
  branchId: UUID;
  treatmentPriceUseCalculation: boolean;
  treatmentPrice: TreatmentPrice;
  incidentalCostUseCalculation: boolean;
  incidentalCost: IncidentalCost;
  totalPrice: number;
  extras: Extra[];
  createdAt: RFC3339timestamp;
  updatedAt: RFC3339timestamp;
} & DocumentOwnership &
  Immutability;

export type TreatmentPrice = {
  basePrice: number;
  relativeDiscount: RelativeDiscount;
  absoluteDiscount: AbsoluteDiscount;
  finalPrice: number;
  postExecutionReduction: PostExecutionReduction;
  postExecutionFinalPrice: number;
};

export type PostExecutionReduction = {
  label: string;
  amount: number;
};

export type RelativeDiscount = {
  active: boolean;
  percentage: number;
};

export type AbsoluteDiscount = {
  active: boolean;
  amount: number;
};

export type IncidentalCost = {
  materialFlatRate: number;
  travelTime: number;
  expenses: number;
  totalAmount: number;
};

export type Extra = {
  id: UUID;
  pricingId: UUID;
  order: number;
  name: string;
  unit: string;
  pricePerUnit: number;
};

export function newExtra(pricingId: UUID): Extra {
  return {
    id: v4(),
    pricingId,
    order: 0,
    name: "",
    unit: "",
    pricePerUnit: 0,
  };
}

export function copyExtra(extra: Extra): Extra {
  return {
    ...extra,
    id: v4(),
  };
}
